import { View } from 'dripsy';
import * as React from 'react';
import { Portal } from '../Portal';
export const AutocompletePortal = ({ isSuggestionListOpen, isInvalid, referenceElement, children, }) => {
    const [, updateState] = React.useState({});
    React.useEffect(() => {
        const onResize = () => updateState({});
        if (ResizeObserver) {
            const observer = new ResizeObserver(onResize);
            observer.observe(document.body);
            return () => {
                observer.disconnect();
            };
        }
        else {
            window.addEventListener('resize', onResize);
            return () => {
                window.removeEventListener('resize', onResize);
            };
        }
    }, []);
    const clientRect = referenceElement.getBoundingClientRect();
    return (React.createElement(Portal, { position: "static", zIndex: "$4" },
        React.createElement(View, { pointerEvents: "none", sx: {
                position: 'absolute',
                borderRadius: 'default',
                boxShadow: 'pop',
                overflow: 'hidden',
                borderColor: isInvalid ? 'errorBackground' : 'infoBorder',
                borderStyle: 'solid',
                borderWidth: 1,
                zIndex: '$4',
            }, style: {
                top: clientRect.top + window.scrollY,
                left: clientRect.left,
                width: clientRect.width,
                paddingTop: isSuggestionListOpen ? clientRect.height - 1 : clientRect.height - 2,
            } }, isSuggestionListOpen && children)));
};
AutocompletePortal.displayName = 'AutocompletePortal';
//# sourceMappingURL=AutocompletePortal.js.map